function filterKeys(obj) {
    let keys = Object.keys(obj);
    let filtered = keys.filter(function (key) {
        return obj[key]
    });
    return filtered[0];
}

async function clientAudioOutputs() {
    const audioOutputs = [];
    const devices = await navigator.mediaDevices.enumerateDevices();
    devices.forEach(device => {
        if (device.kind === 'audiooutput') audioOutputs.push(device.label);
    })
    return audioOutputs;
}

async function paramsToJson() {
    const queryString = window.location.search.slice(1);
    if (!queryString) {
        return false;
    }

    return Object.fromEntries(
        queryString.split('&').map(param => {
            const [key, value] = param.split('=');
            return [key, value];
        })
    );
}

async function clientIdentity() {
    let _ua = null;
    if (!window._ua) {
        _ua = navigator.userAgent.toLowerCase();
    } else {
        _ua = window._ua;
    }

    const audioOutputs = await clientAudioOutputs();
    const params = new URLSearchParams();
    const queryString = await paramsToJson();

    let browser = {
        version: (_ua.match(/.+(?:me|ox|on|rv|it|era|ie)[\/: ]([\d.]+)/) || [0, '0'])[1],
        ua_type: {
            opera: /opera/i.test(_ua),
            msie: (/msie/i.test(_ua) && !/opera/i.test(_ua)),
            msie8: (/msie 8/i.test(_ua) && !/opera/i.test(_ua)),
            msie9: (/msie 9/i.test(_ua) && !/opera/i.test(_ua)),
            mozilla: /firefox/i.test(_ua),
            chrome: /chrome/i.test(_ua),
            safari: (!(/chrome/i.test(_ua)) && /webkit|safari|khtml/i.test(_ua)),
            bada: /bada/i.test(_ua)
        },
        os_type: {
            ios: /(iPhone|iPod|iPad)/i.test(_ua),
            android: /android/i.test(_ua),
            macLike: /(Mac|iPhone|iPod|iPad)/i.test(_ua),
            windows: /windows/i.test(_ua),
            linux: /linux/i.test(_ua),
        },
        device_type: {
            android: /android/i.test(_ua),
            ios: /iphone/i.test(_ua) || /ipad/i.test(_ua),
            desktop: /mac/i.test(_ua) || /windows/i.test(_ua) || /linux/i.test(_ua)
        }
    };
    params.append('ua_version', browser.version);
    params.append('ua_type', filterKeys(browser.ua_type));
    params.append('device_type', filterKeys(browser.device_type));
    params.append('os_type', filterKeys(browser.os_type));
    params.append('media_devices', JSON.stringify(audioOutputs));
    if (queryString) {
        params.append('query_string', JSON.stringify(queryString));
    }
    return params;
}

export {clientIdentity}

